import { createAsyncThunk } from '@reduxjs/toolkit';
import httpService from './httpService';
export const CreateDeal: any = createAsyncThunk<any>(
	'createDeal',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'productService/deal',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const updateDeal: any = createAsyncThunk<any>(
	'updateDeal',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.put('productService/deal', data);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const getDealProductList: any = createAsyncThunk<any>(
	'getDealProductList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'productService/deal/productList',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const addProductInDeal: any = createAsyncThunk<any>(
	'addProductInDeal',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'productService/deal/dealProduct',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getDealListing: any = createAsyncThunk<any>(
	'getDealListing',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get('productService/deal', {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getDealDetails: any = createAsyncThunk<any>(
	'getDealDetails',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'productService/deal/detail',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getCurrentDealProducts: any = createAsyncThunk<any>(
	'getCurrentDealProducts',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'productService/deal/dealProduct',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const updateDealProductData: any = createAsyncThunk<any>(
	'updateDealProductData',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.put(
				'productService/deal/dealProduct',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const deleteDealProducts: any = createAsyncThunk<any>(
	'deleteDealProducts',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.delete(
				'productService/deal/updateProductList',
				{ data }
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const deleteDeals: any = createAsyncThunk<any>(
	'deleteDeals',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.delete('productService/deal', { data });
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const updateDealStatus: any = createAsyncThunk<any>(
	'updateDealStatus',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.patch('productService/deal', data);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const updateDealProductStatus: any = createAsyncThunk<any>(
	'updateDealProductStatus',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'productService/deal/updateProductList',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const updateDealProductSequence: any = createAsyncThunk<any>(
	'updateDealProductSequence',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.put(
				'productService/deal/updateProductList',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const dealProductCheckValidItems: any = createAsyncThunk<any>(
	'dealProductCheckValidItems',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'productService/deal/checkValidItems',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getDealProductValidItems: any = createAsyncThunk<any>(
	'dealProductCheckValidItems',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'productService/deal/dealsProductList',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const getNextDealProducts: any = createAsyncThunk<any>(
	'getNextDealProducts',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'productService/deal/updateProductList',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
